exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".stat[data-v-058e227b]{height:200px}.price[data-v-058e227b]{line-height:150px}.date[data-v-058e227b]{font-size:.5em}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/components/dashboard/PurchasesSum.vue"],"names":[],"mappings":"AACA,uBACE,YAAc,CACf,AACD,wBACE,iBAAmB,CACpB,AACD,uBACE,cAAe,CAChB","file":"PurchasesSum.vue","sourcesContent":["\n.stat[data-v-058e227b] {\n  height: 200px;\n}\n.price[data-v-058e227b] {\n  line-height: 150px;\n}\n.date[data-v-058e227b] {\n  font-size: .5em\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-058e227b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/PurchasesSum.vue
// module id = 837
// module chunks = 0 1 2